import React, { useState } from 'react';
import styles from './SuperUnitNew.module.scss';
import Header from '../../../../components/header/Header';
import UnitEditForm, { EditUnit } from '../edit-form/UnitEditForm';
import { useHistory } from 'react-router-dom';
import { uploadFile } from '../../../../services/File';
import { useCreateUnitMutation, useHeaCreateUnitMutation } from '../../../../api/graphql-codegen';
import { useToast } from '@src/hooks/useToast';
import { useAWSKeys } from '@src/hooks';
import { logger } from '../../../../utils/logger';

function SuperUnitNew() {
  const history = useHistory();
  const { successToast } = useToast();
  const { awsKeys } = useAWSKeys();

  const [createUnit] = useCreateUnitMutation({
    onCompleted(res) {
      if (res.createUnit) {
        successToast('Unit is created successfully!');
      }
    },
    onError(e) {
      logger.debug(`[createUnit error] - `, e);
      setLoading(false);
    },
  });

  const [createHeaUnit] = useHeaCreateUnitMutation({
    onCompleted(res) {
      if (res.heaCreateUnit) {
        successToast('HEA Unit is created successfully!');
      }
    },
    onError(e) {
      logger.debug(`[createHeaUnit error]-`, e);
      setLoading(false);
    },
  });

  const [loading, setLoading] = useState(false);

  const createNewUnit = async (p: EditUnit, isHomeEd?: boolean, heaUnit?: EditUnit) => {
    try {
      setLoading(true);
      let coverImage;
      if (p.coverImage && typeof p.coverImage !== 'string') {
        coverImage = await uploadFile(awsKeys, p.coverImage, 'images');
      }
      const newUnit = await createUnit({
        variables: {
          input: {
            ...p,
            default: !!p.default,
            skill: `${p.skill}`,
            coverImage,
            type: p.type || '0',
          },
        }
      });
      const newUnitId = newUnit.data?.createUnit.id;
      if (heaUnit && newUnitId) {
        try {
          let heaCoverImage;
          if (heaUnit.coverImage && typeof heaUnit.coverImage !== 'string') {
            if (p.coverImage && typeof p.coverImage !== 'string') {
              if (p.coverImage.size === heaUnit.coverImage.size && p.coverImage.name === heaUnit.coverImage.name && p.coverImage.lastModified === heaUnit.coverImage.lastModified) {
                heaCoverImage = coverImage;
              }
            }
            if (!heaCoverImage) {
              heaCoverImage = await uploadFile(awsKeys, heaUnit.coverImage, 'images');
            }
          }
          const { type, ...rest } = heaUnit;
          await createHeaUnit({
            variables: {
              input: {
                ...rest,
                coverImage: heaCoverImage,
                originalUnitId: newUnitId,
              }
            }
          });
        } catch (e) {
          logger.debug(`[newHea error]`, e);
        }
      }
      setLoading(false);
      if (newUnitId) {
        history.push(`/super/units/edit/${newUnitId}`);
      }
    } catch (e) {
      logger.debug(`[e]`, e);
      setLoading(false);
    }
  };

  return (
    <>
      <Header/>
      <div className={styles.page}>
        <div className={styles.list}>
          <div className={styles.programName}>Create Unit</div>
        </div>
        <div className={styles.content}>
          <UnitEditForm loading={loading} onSave={createNewUnit} unit={undefined} setLoading={setLoading} />
        </div>
      </div>
    </>
  );
}

export default SuperUnitNew;
